import {
  PackageOrderItemStatus,
  PackageOrderStatus,
} from 'src/graphql/types/packageOrders'

export const getOrderStatusVariant = (status: PackageOrderStatus | string) => {
  switch (status) {
    case PackageOrderStatus.COMPLETED:
      return 'success'
    case PackageOrderStatus.FAILED:
    case PackageOrderStatus.CANCELLED:
    case PackageOrderStatus.INVITE_EXPIRED:
      return 'error'
    case PackageOrderStatus.PENDING:
    case PackageOrderStatus.SENT:
    case PackageOrderStatus.DRAFT:
    case PackageOrderStatus.SENT_TO_REQUESTOR:
    case PackageOrderStatus.PENDING_APPLICANT:
      return 'warning'
    default:
      return 'primary'
  }
}

// Lead-specific display statuses from DriverIQ case detail mapping.
// Must match LEAD_STATUS_* constants in api/src/lib/driveriq/caseDetail.ts.
const DRIVER_IQ_LEAD_STATUS_CANCELLED = 'CANCELLED'
const DRIVER_IQ_LEAD_STATUS_PENDING_REVIEW = 'PENDING_REVIEW'

export const getItemStatusVariant = (
  status: PackageOrderItemStatus | string
) => {
  switch (status) {
    case PackageOrderItemStatus.COMPLETED:
      return 'success'
    case PackageOrderItemStatus.IN_PROGRESS:
      return 'warning'
    case DRIVER_IQ_LEAD_STATUS_CANCELLED:
      return 'error'
    case DRIVER_IQ_LEAD_STATUS_PENDING_REVIEW:
      return 'warning'
    case PackageOrderItemStatus.NOT_STARTED:
    default:
      return 'primary'
  }
}

export const getItemStatusDotColor = (
  status: PackageOrderItemStatus | string
) => {
  switch (status) {
    case PackageOrderItemStatus.COMPLETED:
      return 'bg-[#2E7D32]'
    case PackageOrderItemStatus.IN_PROGRESS:
      return 'bg-[#ED6C02]'
    case DRIVER_IQ_LEAD_STATUS_CANCELLED:
      return 'bg-[#D32F2F]'
    case DRIVER_IQ_LEAD_STATUS_PENDING_REVIEW:
      return 'bg-[#ED6C02]'
    case PackageOrderItemStatus.NOT_STARTED:
    default:
      return 'bg-[#d0d0d0]'
  }
}
